<template>
    <div :class="!isMobile?'Informations':'mInformations mobileCommon'">
        <p class="SubTitle">{{langPage['mobile-compte']['TXT_title_1']}}</p>

        <el-form label-position="top" :model="acheteur">
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['compte-inscription']['TXT_nom'] }}*</span>
                </slot>
                <el-input class="input" v-model="acheteur.nomContact"></el-input>
            </el-form-item>
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['compte-inscription']['TXT_prenom'] }}*</span>
                </slot>
                <el-input v-model="acheteur.prenomContact"></el-input>
            </el-form-item>
<!--            <el-form-item>-->
<!--                <slot name="label">-->
<!--                    <span class="formLabel">{{ langPage['compte-inscription']['TXT_telephone'] }}</span>-->
<!--                </slot>-->
<!--                <el-input v-model="acheteur.tel" @input="change()"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['panier-livraisons']['TPOPUP_email'] }}* </span>
                </slot>
                <el-input v-model="acheteur.email"></el-input>
            </el-form-item>
            <!-- 旧密码 -->
            <!-- <el-form-item label=" ancien mot de pass* ">
              <el-input  v-model="acheteur.old" show-password></el-input>
            </el-form-item> -->
            <!-- 新密码 -->
            <el-form-item>
                <slot name="label">
                    <span class="formLabel"> {{langPage['v4-informations']['TXT_motdepassesouhaite']}}* </span>
                </slot>
                <el-input v-model="acheteur.password" show-password></el-input>
            </el-form-item>
        </el-form>
        <div class="radio">
            <div v-for="(item,i) in radiolist" :key="i">
                <p class="formLabel">{{item.title}}</p>
                <div class="item">
                    <div v-for="(value,index) in radioitem" :key="index" @click="changeRadio(i,index)">
                        <img
                                :src="item.check==index?require('../../assets/img/Radio-off.svg'): require('../../assets/img/Radio-on.svg')"
                                alt
                        />
                        {{value}}
                    </div>
                </div>
            </div>
        </div>
        <div class="opt">
            <!-- 先去掉该功能 删除我的帐号-->
            <!-- <div>Supprimer mon compte</div> -->
            <button @click="sub">Enregistrer</button>
        </div>
    </div>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: "Informations",

        data() {
            return {
                isMobile: this.$store.state.isMobile,
                submitState: true,
                acheteur: {
                    LangueDefaut: "",
                    active_tva: 0,
                    adresses: [],
                    appel: 0,
                    cgv: 1,
                    commentaires: null,
                    corbeille: 0,
                    data: "",
                    dateCreation: "",
                    dateModification: '',
                    email: "",
                    id_acheteur: '',
                    nbrVotants: 0,
                    newsletter: 1,
                    nomContact: "",
                    nomSociete: "",
                    note: 5,
                    prenomContact: "",
                    saas_client: null,
                    secure_key: "",
                    site_web: "",
                    statut: 1,
                    tva_intra: "",
                    tel: "",
                    old: "",
                    password: ""
                },
                formdata: {
                    nomContact: "",
                    nomSociete: "",
                    prenomContact: "",
                    site_web: "",
                    password: "",
                    LangueDefaut: "",
                    newsletter: 1,
                    facebook: "",
                    instragram: ""
                },
                radioitem: ["Oui", "Non"],
                radiolist: [
                    {
                        title: "Je souscris à la newsletter d’efashion paris",
                        check: 1
                    },
                    // {
                    //   title: "Je reçois des notifications sur l’app",
                    //   check: 1
                    // },
                    // {
                    //   title: "Je reçois des SMS pour les mises à jour de mes commandes",
                    //   check: 1
                    // }
                ]
            };
        },
        created() {
            this.getInfo()
        },
        computed: {
        langPage() {
          return this.$store.state['langPage']
        }
        },
        methods: {
            getInfo() {
                let th = this;
                this.$api.info.getInfo().then(res => {
                    res.password = ''
                    res.old = ''
                    res.facebook = ''
                    th.acheteur = res.acheteur;
                    th.acheteur.LangueDefaut === 'uk' ? th.acheteur.LangueDefaut = 'en' : th.acheteur.LangueDefaut
                    // console.log(th.acheteur)
                    th.acheteur.tel = res.acheteur.data ? JSON.parse(res.acheteur.data).telephone : "";
                    th.$store.commit('set', {key: "acheteurId", value: th.acheteur.id_acheteur});
                    this.radiolist[0].check =th.acheteur.newsletter;
                })
            },

            changeRadio(i, index) {
                this.radiolist[i].check = index == 0 ? 1 : 0;
                this.radiolist.splice(i, 1, this.radiolist[i]);
                this.acheteur.newsletter = this.radiolist[i].check
            },
            sub() {
                if (!this.submitState) return
                this.submitState = false
                for (var key in this.formdata) {
                    for (var key1 in this.acheteur) {
                        if (key1 == key) this.formdata[key] = this.acheteur[key]
                    }
                }
                this.$api.info.updateInfo(this.formdata).then(res => {
                    if (res.code == 1) this.getInfo()
                    if (res.code === 0) this.$message.success("submit success");
                }).finally(() => {
                    this.submitState = true
                })
            },
            change(){
                this.$forceUpdate();
            }
        }
    };
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Informations.less">
</style>
